import React from 'react'
import { IoMdArrowUp } from 'react-icons/io'

const StatCard = ({ title, count }) => {
  return (
    <div className="bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-lg p-4 md:p-5 dark:bg-dark bg-white w-full">
      <p className="font-medium text-black dark:text-white text-sm capitalize mb-3">{title}</p>
      <div className='flex flex-row items-center justify-between'>
        <p className="font-extrabold text-2xl dark:text-white capitalize ">{count}</p>

        <div className='py-1.5 px-2 bg-yellowcolor/30 dark:bg-[#FEECB8] rounded-full flex flex-row items-center gap-1'>
          <IoMdArrowUp className='text-dark-yellow text-xs' />
          <p className='text-dark-yellow text-xs font-medium'>
            100%
          </p>
        </div>
      </div>
    </div>
  )
}

export default StatCard